import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

const Footer = () => {
  const appName = process.env.REACT_APP_APP_NAME || 'CRM Automax';

  return (
    <footer className="marketing-footer" style={{ padding: '80px 48px 40px', borderTop: '1px solid #f1f5f9', background: '#ffffff' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', gap: '60px', flexWrap: 'wrap', marginBottom: '60px' }}>
        <div style={{ flex: '0 0 300px' }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px', textDecoration: 'none', color: '#1e293b' }}>
            <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: 'linear-gradient(135deg, #3b82f6, #2563eb)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <ShieldCheck size={16} color="white" />
            </div>
            <span style={{ fontWeight: '800', fontSize: '16px' }}>{appName}</span>
          </Link>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: 1.6 }}>
            The all-in-one CRM for lead management, WhatsApp automation, and bulk email campaigns. 
            Built for performance-driven teams and agencies.
          </p>
        </div>
        
        <div style={{ display: 'flex', gap: '80px', flexWrap: 'wrap' }}>
          <div>
            <div style={{ fontWeight: '700', marginBottom: '20px', color: '#1e293b' }}>Product</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link to="/features" style={{ textDecoration: 'none', color: '#64748b', fontSize: '14px' }}>Features</Link>
              <Link to="/pricing" style={{ textDecoration: 'none', color: '#64748b', fontSize: '14px' }}>Pricing</Link>
              <Link to="/about-us" style={{ textDecoration: 'none', color: '#64748b', fontSize: '14px' }}>About Us</Link>
            </div>
          </div>
          <div>
            <div style={{ fontWeight: '700', marginBottom: '20px', color: '#1e293b' }}>Legal</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link to="/privacy-policy" style={{ textDecoration: 'none', color: '#64748b', fontSize: '14px' }}>Privacy Policy</Link>
              <Link to="/terms" style={{ textDecoration: 'none', color: '#64748b', fontSize: '14px' }}>Terms & Conditions</Link>
              <Link to="/payment-policy" style={{ textDecoration: 'none', color: '#64748b', fontSize: '14px' }}>Refund Policy</Link>
              <Link to="/cookie-policy" style={{ textDecoration: 'none', color: '#64748b', fontSize: '14px' }}>Cookie Policy</Link>
            </div>
          </div>
          <div>
            <div style={{ fontWeight: '700', marginBottom: '20px', color: '#1e293b' }}>Contact</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link to="/contact" style={{ textDecoration: 'none', color: '#64748b', fontSize: '14px' }}>Contact Us Form</Link>
              <a href="mailto:support@crmautomax.com" style={{ textDecoration: 'none', color: '#64748b', fontSize: '14px' }}>support@crmautomax.com</a>
              <div style={{ color: '#64748b', fontSize: '14px' }}>+91 86699 30119 (Sales)</div>
            </div>
          </div>
        </div>
      </div>
      
      <div style={{ textAlign: 'center', paddingTop: '40px', borderTop: '1px solid #f1f5f9', color: '#94a3b8', fontSize: '13px' }}>
        © {new Date().getFullYear()} {appName}. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
